import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPromptTextToVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"prompt-text-to-video"} maskId="square-filled-radius-0-stroke-1-IconPromptTextToVideo"><path d="M21 21H5V15H6V20H20V6H13V5H21V21Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M16.4014 13L10.5 16.9346V9.06543L16.4014 13ZM11.5 15.0654L14.5986 13L11.5 10.9336V15.0654Z" fill="currentColor"/><path d="M10 5H9V4H6V11H7V12H4V11H5V4H2V5H1V3H10V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPromptTextToVideo;
